<template>
  <label :class="$style.switcher">
    <input type="checkbox" :checked="checked" :value="value" v-on="$listeners" />
    <span :class="$style.switch"></span>
  </label>
</template>

<script>
export default {
  name: 'CookieSwitcher',
  props: {
    value: String,
    checked: Boolean,
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

$switcherBg: rgba(29, 29, 31, 0.3);
$switcherBgHover: rgba(29, 29, 31, 0.4);
$switcherBgActive: #000;
$switcherItemBg: #fff;

.switcher {
  @include mixins.size(5rem, 2.8rem);

  position: absolute;
  top: 16px;
  right: 0;
  display: inline-block;

  @include mixins.hover {
    &:hover {
      .switch {
        background: $switcherBgHover;
      }
    }
  }

  input {
    @include mixins.size(0);

    opacity: 0;

    &:checked + .switch {
      background-color: $switcherBgActive;
    }

    &:checked + .switch::before {
      transform: translateX(22px);
    }
  }
}

.switch {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: $switcherBg;
  border-radius: 40px;
  cursor: pointer;
  transition: 0.4s;

  &::before {
    @include mixins.size(24px);

    position: absolute;
    bottom: 2px;
    left: 2px;
    background-color: $switcherItemBg;
    border-radius: 50%;
    content: '';
    transition: 0.4s;
  }
}
</style>
